import styled from 'styled-components';

export const Container = styled.main`
  min-height: 100%;
  padding: 50px;
  background-color: ${({ theme }) => theme.colors.white};
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    padding: 30px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;

  > header {
    margin-bottom: 24px;

    h1 {
      margin: 0;
      color: ${({ theme }) => theme.colors.black};
      font-size: 28px;
    }

    p {
      margin: 8px 0 0;
      color: ${({ theme }) => theme.colors.grey};
      font-size: 14px;
    }
  }
`;
